// @flow
import { combineReducers } from 'redux-immutable';
import action from './action/reducer';
import article from './article/reducer';
import scan from './scan/reducer';
import category from './category/reducer';
import connection from './connection/reducer';
import device from './device/reducer';
import filter from './filter/reducer';
import filterSelection from './filterSelection/reducer';
import filterReducer from './filterSelections/filterReducer';
import identity from './identity/reducer';
import intl from './intl/reducer';
import primaryCategory from './primaryCategory/reducer';
import session from './session/reducer';
import store from './store/reducer';
import theme from './theme/reducer';
import watchlist from './watchlist/reducer';
import inspiration from './inspiration/reducer';
import department from './department/reducer';
import error from './error/reducer';
import sort from './sort/reducer';
export default combineReducers({
    action: action,
    article: article,
    scan: scan,
    category: category,
    connection: connection,
    department: department,
    device: device,
    filter: filter,
    filterSelection: filterSelection,
    identity: identity,
    inspiration: inspiration,
    intl: intl,
    primaryCategory: primaryCategory,
    session: session,
    store: store,
    theme: theme,
    watchlist: watchlist,
    error: error,
    sort: sort,
    filterReducer: filterReducer,
});
